import posthog from 'posthog-js';
import { isClient } from '#/utils/general';

/**
 * Get the PostHog SDK.
 *
 * @returns the PostHog SDK
 */
export function getPosthog() {
  if (!isClient()) {
    return null;
  }

  return posthog;
}
